module.exports = __webpack_public_path__ + "media/application/images/ui/confirm-email-518cc7423c12102e6ccfbab742cc7310.png";